import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import * as Styled from "./simple-box.style";
import { LoadingOverlay } from "ui/components/elements/loading-overlay";
import { DelayedFallback } from "ui/utility/delayed-fallback";
export var SimpleBox = function (_a) {
    var children = _a.children, isLoading = _a.isLoading, _b = _a.roundedCorners, roundedCorners = _b === void 0 ? "top" : _b, className = _a.className;
    return (_jsxs(Styled.SimpleBox, { roundedCorners: roundedCorners, className: className, children: [children, _jsx(DelayedFallback, { isLoading: isLoading, fallback: _jsx(LoadingOverlay, {}) })] }));
};
